import React, { Dispatch, SetStateAction } from 'react';
import { InscriptionStatus } from '../../../services/central-api/third-party-approved-companies';
import { Modal, View } from 'react-native';
import MyAppText from '../../../components/MyAppText';
import FormActions from '../../../components/FormActions';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../../services/window-information';
import { translate } from '../../../services/translate';
import { parseTextWithBold } from '../../deac/DeacCommons';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    mode: 'publish' | 'unpublish';
    onConfirm: (status: InscriptionStatus) => void;
}

export default function InscriptionPublishConfirmModal({ isModalVisible, mode, onConfirm, setModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    function closeModal() {
        setModalVisible(false);
    }

    function formSubmit() {
        onConfirm(mode === 'publish' ? 'published' : 'approved');
        closeModal();
    }

    return (
        <Modal
            transparent
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => closeModal()}
        >
            <View style={styles.container}>
                <View style={styles.formContainer(windowInfo.isMobile)}>
                    <View style={{ flexDirection: 'column', rowGap: 16 }}>
                        <View style={{ flexDirection: 'column', rowGap: 8 }}>
                            <MyAppText style={styles.header}>{translate(mode === 'publish' ? 'confirmInscriptionPublishTitle' : 'confirmInscriptionUnpublishTitle')}</MyAppText>
                            <MyAppText style={styles.subheader}>{parseTextWithBold(translate(mode === 'publish' ? 'confirmInscriptionPublishMessage' : 'confirmInscriptionUnpublishMessage'))}</MyAppText>
                        </View>
                        <MyAppText style={styles.subheader}>{translate(mode === 'publish' ? 'confirmInscriptionPublishQuestion' : 'confirmInscriptionUnpublishQuestion')}</MyAppText>
                    </View>

                    <FormActions
                        viewStyle={{ width: '100%', flex: 1, justifyContent: 'space-around' }}
                        buttonContentContainerStyle={{ flex: 1 }}
                        cancelText='goBack'
                        confirmText='confirm'
                        onSubmit={formSubmit}
                        onClose={closeModal}
                        disabled={false}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    formContainer: (isMobile: boolean) => ({
        width: isMobile ? '95%' : 450,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32,
        alignItems: 'center'
    }),
    header: {
        fontSize: 18,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
    },
    subheader: {
        fontSize: 16,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    }
}));
